export default __webpack_public_path__ + "static/media/pythonback.526537f0.svg";